import * as ActionTypes from '../constants/actiontypes/referent';
import *  as axios from 'axios';
import * as urls from '../constants/webapi/userRepresentativeSelfcare';
import { getAuthenticationUrl } from '../constants/webapi/auth';



export function postUserRepresentativeSelfcareJwt(id, password) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.AUTHENTICATE_REQUEST });
		return axios.post(urls.userRepresentativeSelfcareAuthByIdUrl(id), { password })
			.then((response) => {
				dispatch({
					type: ActionTypes.AUTHENTICATE_SUCCESS,
					data: response.data,
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.AUTHENTICATE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserRepresentativeSelfcare(id) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USERREPRESENTATIVE_REQUEST });
		return axios.get(urls.userRepresentativeByIdUrl(id))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USERREPRESENTATIVE_SUCCESS,
					data: response.data,
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 404) {
					window.location = "index";
					return;
				}
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USERREPRESENTATIVE_FAILURE,
					response: error.response,
					referentId: id
				});
				throw error.statusText;
			});
	};
}

export function updateUserRepresentativeSelfcare(id, userData) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_USERREPRESENTATIVE_REQUEST });
		return axios.put(urls.userRepresentativeByIdUrl(id), userData)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_USERREPRESENTATIVE_SUCCESS,
					data: response.data,
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 404) {
					window.location = "index";
					return;
				}
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_USERREPRESENTATIVE_FAILURE,
					response: error.response,
					referentId: id
				});
				throw error.statusText;
			});
	};
}

export function linkUserRepresentativeSelfcareJwt(id) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.LINK_REQUEST });
		return axios.get(urls.userRepresentativeSelfcareLinkByIdUrl(id))
			.then((response) => {
				dispatch({
					type: ActionTypes.LINK_SUCCESS,
					data: response.data,
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.LINK_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}
